var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"MainFilter max-h-full"},[_c('main-filter-component-new',{class:{
      'pt-10':
        this.$vuetify.breakpoint.name !== 'sm' &&
        this.$vuetify.breakpoint.name !== 'xs',
    },attrs:{"type":_vm.getType,"size":`${_vm.$route.params.size}`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }